// Special case for PDFs, which were getting set as 'application' instead of 'pdf'
export function getFileType(mimeType: string | null | undefined, fileName: string) {
    if (fileName.endsWith('.pdf')) {
        return 'pdf';
    }

    return mimeType ? mimeType.split('/')[0] : '';
}
